'use client';

import { Link } from '@//components/Link';
import { useLegacyTrackManufacturerPackagePageGotoSearch } from '@//data/tracking/useLegacyTrackManufacturerPackagePageGotoSearch';

interface GuaranteePackageLinkProps {
  href: string;
  title: string;
  packageName: string;
  children: React.ReactNode;
}

export const GuaranteePackageLink: React.FC<GuaranteePackageLinkProps> = ({
  href,
  title,
  packageName,
  children,
}) => {
  const { trackLegacyManufacturerPackagePageGotoSearch } =
    useLegacyTrackManufacturerPackagePageGotoSearch();

  const handleClick = () => {
    trackLegacyManufacturerPackagePageGotoSearch('bottom', packageName);
  };

  return (
    <Link href={href} title={title} onClick={handleClick}>
      {children}
    </Link>
  );
};
